import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Performances() {
  const [performances, setPerformances] = useState([]);

  useEffect(() => {
    fetch("/api/admin/medias/performances.php")
      .then(res => res.json())
      .then(data => setPerformances(data));
  }, []);

  return (
    <div className="container" style={{ maxWidth: "1200px" }}>
        <div className="projects-column">
            {performances.map((p, i) => (
              <Link key={i} className="project-wrapper" target="blank" to={`${p.link}`}>
                  <div
                    className="project-card"
                    style={{ backgroundImage: 'url(' + p.image + ')'}}
                  >
                    <div className="project-overlay">

                      <h3
                        className="display-4"
                        style={{ fontFamily: "pangram-sans-semiBold" }}
                      >
                        {p.title.toUpperCase()}
                      </h3>
                      <h5
                        style={{ marginLeft:'15%', fontFamily: "pangram-eiko-lightItalic", letterSpacing:'0.5px'}}
                      >
                        {p.desc}
                      </h5>
                    </div>
                  </div>
              </Link>
              ))}
        </div>
    </div>
  );
}